var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLeftStartOnRectangle = function SvgArrowLeftStartOnRectangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#18181B",
    d: "M16.5 2.25a3 3 0 0 1 3 3v13.5a3 3 0 0 1-3 3h-6a3 3 0 0 1-3-3V15A.75.75 0 0 1 9 15v3.75a1.5 1.5 0 0 0 1.5 1.5h6a1.5 1.5 0 0 0 1.5-1.5V5.25a1.5 1.5 0 0 0-1.5-1.5h-6A1.5 1.5 0 0 0 9 5.25V9a.75.75 0 0 1-1.5 0V5.25a3 3 0 0 1 3-3zM4.72 8.47a.75.75 0 1 1 1.06 1.06l-1.72 1.72H15a.75.75 0 0 1 0 1.5H4.06l1.72 1.72a.75.75 0 0 1-1.06 1.06l-3-3a.75.75 0 0 1 0-1.06z"
  })));
};
export default SvgArrowLeftStartOnRectangle;